import BenefitIllustration from './components/benefit-illustration'

import { connect } from 'react-redux'
import { hasProductSelected } from 'quick-quote/selectors/selected-display-product'

import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'
import { getGenderLabel, getAge } from 'quick-quote/insured-information/selectors'
import { isBlockedPdfGeneration, isBlockedEnteringESub, isReviseQQFlow } from 'quick-quote/selectors'
import {
  getSumAssured$,
  getBasicPremium$,
  getTotalPremium,
  getSelectedRiders,
  getTotalRiderPremium,
  getcoveragePlanStartDate,
  getSelectedModelFactorLabel,
  getSelectedModelFactorPeriod,
} from 'quick-quote/product-common/coverage-plan/selectors'
import {
  getCalculatedCoveragePeriod,
  getCalculatedPaymentPeriod,
  getHasShowDisclaimerRiderAsterisk,
  getIsCheckRiderCampaignDiscountActive,
  getMappingRiderCampaignDiscountBIMessage,
} from 'quick-quote/product-common/benefit-illustration/selectors'
import {
  getPolicyValues,
  getHasNonLevelRider,
  getLegalDisclaimerEndDate,
  getTaxDeduction,
} from 'quick-quote/product-whole-life/benefit-illustration/selectors'

import { getDisplayBenefitSummaryTable } from 'quick-quote/v2/products/customs/12pl/components/benefit-summary-table/selectors'

import { getProfileSummaryHeader } from './selectors'

const mapStateToProps = (state) => ({
  displayProduct: getSelectedDisplayProduct(state),
  riders: getSelectedRiders(state),
  genderLabel: getGenderLabel(state),
  age: getAge(state),
  hasProductSelected: hasProductSelected(state),
  sumAssured$: getSumAssured$(state),
  basicPremium$: getBasicPremium$(state),
  totalPremium: getTotalPremium(state),
  totalRiderPremium: getTotalRiderPremium(state),
  selectedModelFactorLabel: getSelectedModelFactorLabel(state),
  selectedModelFactorPeriod: getSelectedModelFactorPeriod(state),
  calculatedCoveragePeriod: getCalculatedCoveragePeriod(state),
  calculatedPaymentPeriod: getCalculatedPaymentPeriod(state),
  hasNonLevelRider: getHasNonLevelRider(state),
  hasShowDisclaimerRiderAsterisk: getHasShowDisclaimerRiderAsterisk(state),
  isBlockedPdfGeneration: isBlockedPdfGeneration(state),
  isBlockedEnteringESub: isBlockedEnteringESub(state),
  coveragePlanStartDate: getcoveragePlanStartDate(state),
  legalDisclaimerEndDate: getLegalDisclaimerEndDate(state),
  policyValue: getPolicyValues(state),
  profileSummaryHeader: getProfileSummaryHeader(state),
  taxDeduction: getTaxDeduction(state),
  benefitSummaryProps12PL: getDisplayBenefitSummaryTable(state),
  isReviseQQ: isReviseQQFlow(state),
  isCheckHaveRiderCampaignDiscountActive: getIsCheckRiderCampaignDiscountActive(state),
  riderCampaignDiscountBIMessage: getMappingRiderCampaignDiscountBIMessage(state),
})

const mapDispatchToProps = () => ({})

export const BenefitIllustrationContainer = connect(mapStateToProps, mapDispatchToProps)(BenefitIllustration)
